import platform from "../../../util/platform";
const create = (request) => {
    return (params) => {
        const path = `/progress/vendor/document/create`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const getSignedUploadUrl = (request) => {
    return (params) => {
        const path = `/progress/vendor/document/upload/signed`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const uploadSignedDocumentToS3 = (url, file) => {
    const reqInit = {
        method: 'PUT',
        body: file,
    };
    return fetch(url, reqInit);
};
const vendorDocument = {
    create,
    getSignedUploadUrl,
    uploadSignedDocumentToS3
};
export default vendorDocument;
